// Source unique des administrateurs Festin (frontend).
// ⚠️ À garder SYNCHRONISÉE avec la fonction isAdmin() de `firestore.rules` :
//   - cette liste contrôle l'affichage de la PAGE admin ;
//   - isAdmin() dans firestore.rules contrôle l'accès aux DONNÉES.
// Un email présent ici mais absent des règles verrait la page admin mais
// aucune donnée (toutes les requêtes Firestore seraient refusées).
export const ADMIN_EMAILS = [
  'azurio.music@gmail.com',
  'arieberrebi@gmail.com',
  'contact@mashalove.com',
];

/** L'utilisateur (par email) est-il administrateur ? Insensible à la casse. */
export function isAdminEmail(email?: string | null): boolean {
  return !!email && ADMIN_EMAILS.includes(email.toLowerCase());
}
